import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import "../CSS/Navbar.css";
import { useDispatch, useSelector } from "react-redux";
import { setDivision } from "../Redux/Action/division";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
// import { logIn } from "../../Redux/Action";

const DashboardLoginNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showreports, setshowreports] = useState(false);
  const [showreports2, setshowreports2] = useState(false);
  const [showMaster, setShowMaster] = useState(false);
  const [showTransaction, setShowTransaction] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const state = useSelector((state) => state.changeTheState.user);
  const division = useSelector((state) => state?.DivisionReducer);
  const userName = state?.emailId?.split("@")[0].toUpperCase();
  const BASEURL = process.env.REACT_APP_BASEURL;
  //   const authToken = window.sessionStorage.getItem("auth-token");

  function logOut() {
    // dispatch(logIn([]));
    dispatch(setDivision(""));
    navigate("/");
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="centernav">
      <div className="navbar-container uppercase">
        {/* <nav className="navbar">
          <div className="">
            <div className="fabar" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
            <div className="hover-dropdown">
              <ul className="ul__list__style__scanner">
                <div>
                  <p
                    onClick={() => {
                      navigate("/ListofOrdersKitchen");
                    }}
                  >
                    List Of Orders Started
                  </p>
                  <p
                    onClick={() => {
                      navigate("/ListofOrdersNotStarted");
                    }}
                  >
                    List Of Order Not Started
                  </p>
                </div>
              </ul>
            </div>
          </ul>
        </nav> */}
        <div className="logedIn__as__btn">
          <h2>Welcome to MarsTrack POS DASHBOARD</h2>
          <h3 className="hidden lg:block">
            {" "}
            Logged in as : {userName ? userName : "N/A"}{" "}
          </h3>
          {/* {state.emailId.split("@")[0].toUpperCase()}</h3> */}
        </div>

        <aside>
          <button onClick={logOut} className="button__logout__navbar">
            {" "}
            LOGOUT
          </button>
        </aside>
        <div className="logout__fullscren">
          <button onClick={logOut} className="log__out__icon">
            {" "}
            <FiLogOut />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default DashboardLoginNavbar;
